<template>
  <div id="app">
    <a-config-provider :locale="locale">
      <router-view />
    </a-config-provider>
  </div>
</template>

<script>
import store from '@/store/store';
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
let _this = '';

// <!-- 七鱼客服 -->
(function (w, d, n, a, j) {
  w[n] = w[n] || function () {
    (w[n].a = w[n].a || []).push(arguments);
  };
  j = d.createElement('script');
  j.async = true;
  j.src = 'https://qiyukf.com/script/2ce4e13d4d55bc4defc7de9a1e63dcd3.js';
  d.body.appendChild(j);
})(window, document, 'ysf');

var isSdkReady = false;
ysf('onready', function () {
  isSdkReady = true;
  console.log('七鱼客服sdk ready');
})

var handleCustomerBtn_qy = function () {
  console.log({
    uid: store.state.user.userInfo.userId,      // 用户Id
    name: store.state.user.userInfo.myName,          // 用户名称
    email: '', // 用户邮箱
    mobile: store.state.user.userInfo.userName // 用户电话
  });

  if (!store.state.user.userInfo.userId) {
    ysf('config', {});
  }

  if (isSdkReady) {
    ysf('open');
  } else {
    // 仅做参考
    console.log('sdk尚未加载成功，请稍后再试');
  }
}

// 初始化七鱼客服
window.customQyInit = function () {
  ysf('config', {
    uid: store.state.user.userInfo.userId,      // 用户Id
    name: store.state.user.userInfo.myName,          // 用户名称
    mobile: store.state.user.userInfo.userName // 用户电话
  });
}

// 销毁七鱼客服
window.customQyOff = function () {
  ysf('logoff');
  // console.log("登出七鱼-注销用户")
}

export default {
  store, // 引用
  data () {
    return {
      locale: zhCN,
      price: 2.33,
      metaData: []
    }
  },
  metaInfo () {
    return {
      meta: this.metaData
    }
  },
  filters: {
    currency (value, symbol = '￥') {
      return symbol + value
    }
  },
  watch: {
    $route (to, from) {
      if (!to.meta) {
        return false
      }

      let title = '快贴宝', keywords = '', description = ''

      if (to.query.title) {
        title = to.query.title + '-快贴宝'
        keywords = to.query.title
        description = to.query.content || ''
      } else {
        title = to.meta.title || title
        keywords = to.meta.keywords || ''
        description = to.meta.description || ''
      }

      document.title = title

      console.log('title:', title, 'keywords:', keywords, 'description:', description, 'document.title:', document.title, '=====');

      this.metaData = [
        { name: 'keywords', content: keywords },
        { name: 'description', content: description }
      ]
    },
  },
  created () {
    _this = this;
    window.handleCustomerBtn_qy = handleCustomerBtn_qy;

    // 在页面加载时读取localStorage里的状态信息
    if (localStorage.getItem('loginParam')) {
      let publicData = this.$store.state.publicData
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(localStorage.getItem('loginParam'))))
      this.$store.state.publicData = publicData
      localStorage.setItem('loginParam', JSON.stringify(_this.$store.state))

      _this.removeQuickLoginToken()  // 移除quickLoginToken，如果有的话
    } else {
      _this.quickLogin()
    }

    this.$Message.config({
      top: 250,
      duration: 3
    });

    this.$nextTick(function () {
      if (this.isIos()) {
        document.getElementById('body').style.minHeight = "2300px";
      }
    })
  },
  mounted: () => {
    // 监听窗口尺寸改变
    _this.getWH();
    window.onresize = function () {
      _this.getWH();
    }
  },
  methods: {
    close_popups: function () {
      this.showPopups = false;
    },
    getWH () {
      _this.$store.state.windowResizeW = document.documentElement.clientWidth
      _this.$store.state.windowResizeH = document.documentElement.clientHeight
      // console.log('w', _this.$store.state.windowResizeW, 'h', _this.$store.state.windowResizeH)
    },
    // 快速登录token
    quickLogin () {
      // 检查参数是否存在quickLoginToken
      let url = window.location.href;             //获取当前url
      if (url.indexOf('quickLoginToken=') >= 0) {
        let token = url.split('quickLoginToken=')[1]
        if (token.indexOf('&') >= 0) {
          token = token.split('&')[0]
        }
        // 快速登录认证
        this.sendGet({
          url: '/web/discount/quickLogin',
          data: { quickLoginToken: token }
        }, (result) => {
          if (result.data.data) {
            localStorage.setItem("isLogin", JSON.stringify({
              isLogin: true,
              time: new Date().getTime(),
            }));
            // 获取用户信息
            store.state.userId = result.data.data.userId;
            store.state.userPhone = result.data.data.userName;
            store.state.user.userInfo = result.data.data;
            localStorage.setItem("loginParam", JSON.stringify(store.state));

            // 清除token
            url = url.replace(new RegExp('[&|?]quickLoginToken=' + token), '')
            window.open(url, '_self')
          }
        }, () => { })

      }
    },
    // 移除快速登录token
    removeQuickLoginToken () {
      let url = window.location.href;             //获取当前url
      if (url.indexOf('quickLoginToken=') >= 0) {
        let token = url.split('quickLoginToken=')[1]
        if (token.indexOf('&') >= 0) {
          token = token.split('&')[0]
        }
        // 清除token
        url = url.replace(new RegExp('[&|?]quickLoginToken=' + token), '')
        window.open(url, '_self')
      }
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
#app {
  width: 100%;
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#YSF-BTN-HOLDER {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue